import io from 'socket.io-client';

const ENDPOINT = process.env.REACT_WEB_SOCKET_API_URL; // en prod: 'wss://api.signly.cloud'; en local http://localhost:3000;
let socket;

export const connectToSocket = () => {
  if (socket && socket.connected) {
    return socket;
  }

  if (socket) {
    socket.connect();
    return socket;
  }

  socket = io(ENDPOINT, {
    withCredentials: true,
    transports: ['websocket', 'polling']
  });

  socket.on('connect', () => {
    // console.log('Conectado al servidor de Socket.IO');
  });

  // La cuenta inició sesión en otro dispositivo (o la sesión ya no es la
  // vigente al reconectar). App.jsx decide si cerrar sesión en esta pestaña.
  socket.on('session_replaced', (data) => {
    window.dispatchEvent(new CustomEvent('signly:session-replaced', { detail: data || {} }));
  });

  return socket;
};

export const joinDocument = (docId) => {
  if (socket) {
    socket.emit('joinDocument', docId);
  }
};

export const disconnectSocket = (reason = 'disconnect') => {
  if (socket) {
    const socketToDisconnect = socket;
    socket = null;

    if (reason === 'logout' || reason === 'leave') {
      if (reason === 'logout') {
        socketToDisconnect.emit('logout');
      }
      setTimeout(() => {
        if (socketToDisconnect.connected) {
          socketToDisconnect.disconnect();
        }
      }, 500);
    } else {
      socketToDisconnect.disconnect();
    }
  }
};
